import { useMemo } from 'react';
import { useAuth } from '@/contexts/auth';
import { useOvertime } from '@/contexts/overtime/useOvertime';
import { processAnalyticsData, FilterOptions, ProcessedOvertimeData } from '@/utils/analyticsUtils';

/**
 * Consolidated analytics hook that eliminates redundant calculations
 * across all home page analytics components
 */
export const useConsolidatedAnalytics = (filters: FilterOptions) => {
  const { user } = useAuth();
  const { overtimeRequests, employees } = useOvertime();

  const analyticsData = useMemo((): ProcessedOvertimeData => {
    return processAnalyticsData(
      overtimeRequests || [],
      employees || [],
      filters,
      user
    );
  }, [overtimeRequests, employees, filters, user]);

  return {
    ...analyticsData,
    isLoading: !overtimeRequests || !employees,
    user
  };
};
